import { CompartmentCard } from "@/src/components/cards";
import { closeDrawer } from "@/src/components/dialogs";
import { FetchableList } from "@/src/components/fetchableLists";
import {
  Exam,
  ExamStep,
  Patient,
  PatientDocument,
  Sample,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import {
  addPaddingToNumber,
  addSpacingToNumber,
  getItemId,
  getRandomInt,
  getRandomString,
  getServiceId,
  getUserId,
} from "@/src/utils/utils";
import { useState } from "react";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import AnapathSampleCard from "./anapathSampleCard";
import { openAnapathSampleForm } from "./anapathSampleForm";
import { openExamStepsPicker } from "./examStepsPicker";
import { openSampleTypePicker } from "./sampleTypePicker";
import { Button } from "@/src/components/buttons";
import moment from "moment";
import { openUsersCheckboxList } from "../admin/users/usersHook";

export default function AnapathSamplesCompartment({
  exam,
  patient,
  onDocumentCreate,
  onDocumentValidate,
}: {
  exam: Exam;
  patient: Patient;
  onDocumentCreate: (document: PatientDocument) => void;
  onDocumentValidate: (document: PatientDocument) => void;
}) {
  const [reload, setReload] = useState(0);
  const [searchKey, setSearchKey] = useState<string | null>(null);

  return (
    <div className="c1 gap10">
      <FetchableList
        queryKey={["anapathSamples", exam.id, reload]}
        queryFn={() =>
          apiFetch("samples", "loadMany", {
            // parentId: getItemId(exam),
            examId: getItemId(exam),
            patientId: getItemId(exam.patient),
          })
        }
        emptyChild={
          <div className="c1 gap20 center p20">
            <div className="gray">Aucune pièce trouvée</div>
            <Button
              type="tertiary"
              onClick={async () => {
                await addAnapathSample({
                  sample: null,
                  exam,
                  onChange: (sample) => {
                    setReload(reload + 1);
                  },
                });
              }}
            >
              Ajouter une pièce/échantillon
            </Button>
          </div>
        }
      >
        {(samples) => (
          <div className="c3 mc1 gap20">
            {samples?.map((sample) => {
              return (
                <AnapathSampleCard
                  key={sample.id}
                  sample={sample}
                  patient={patient}
                  onDocumentCreate={onDocumentCreate}
                  onDocumentValidate={onDocumentValidate}
                  onChange={(sample) => {
                    setReload(reload + 1);
                  }}
                />
              );
            })}
            <Button
              type="tertiary"
              onClick={async () => {
                await addAnapathSample({
                  sample: null,
                  exam,

                  onChange: (sample) => {
                    setReload(reload + 1);
                  },
                });
              }}
            >
              +
            </Button>
          </div>
        )}
      </FetchableList>
    </div>
  );
}

export async function addAnapathSample({
  sample,
  exam,
  onChange,
  shouldAddInitialSteps,
  shouldShowSteps = true,
}: {
  sample: Sample | null | undefined;
  shouldAddInitialSteps?: boolean;
  exam: Exam;
  shouldShowSteps?: boolean;
  onChange: (sample: Sample) => void;
}) {
  sample ||= {
    type: "sample",
    barcode: "",
    exams: [exam],
    numberOfPieces: 1,
    targetService: getServiceId(),
    status: "inProgress",
    patient: exam.patient,
    creator: getUserId(),
    readBy: [],
    steps: [],
    confidentiality: getStandardConfidentiality(exam.patient),
    refAnswer: {
      fieldAnswers: [],
      creator: getUserId(),
      reference: null,
      patient: exam.patient,
    },
    externalDemandId: null,
  };

  sample.barcode = `${addPaddingToNumber(getRandomInt(4), 6)}/${moment().format(
    "YY"
  )}`;

  closeDrawer("sampleChoiceDrawer");
  openAnapathSampleForm({
    sample,
    isSimplified: true,
    onSave: async (sample) => {
      if (shouldAddInitialSteps == true)
        sample = await addInitialSteps({ sample, exam });
      if (!shouldShowSteps) return onChange(sample);

      await openExamStepsPicker({
        current: [],
        onConfirm: async (examSteps) => {
          await openUsersCheckboxList({
            serviceId: getServiceId(),
            title: "Choisir les utilisateurs",
            selectedUsers: [],
            onConfirm: async (users) => {
              sample.steps = [];
              for (const examStep of examSteps) {
                sample.steps.push({
                  type: "examStep",
                  status: "pending",
                  parent: getItemId(sample),
                  patient: getItemId(sample.patient),
                  reference: getItemId(examStep),
                  creator: getUserId(),
                  confidentiality: null,
                  content: null,
                  readBy: [],
                  affectedTo: users,
                });
              }
              sample = await apiFetch("samples", "addOne", {
                sample,
              });
              onChange(sample);
            },
          });
        },
      });
      onChange(sample);
    },
  });
}

async function addInitialSteps({
  sample,
  exam,
}: {
  sample: Sample;
  exam: Exam;
}) {
  let anapathInitialStepReferences = await apiFetch(
    "references",
    "loadInitialStepReferences",
    {
      referenceId: getItemId(exam.reference),
    }
  );

  console.log("iniiiital", anapathInitialStepReferences);

  sample.steps ||= [];

  for (let stepReference of anapathInitialStepReferences) {
    let step: ExamStep = {
      reference: stepReference,
      patient: getItemId(sample.patient),
      creator: getUserId(),
      readBy: [],
      status: "pending",
      parent: getItemId(sample),
      affectedTo: [],
      type: "examStep",
      content: {
        fieldAnswers: [],
        creator: getUserId(),
        reference: stepReference,
        patient: getItemId(sample.patient),
      },
      confidentiality: getStandardConfidentiality(sample.patient),
    };
    sample.steps.push(step);
  }

  sample = await apiFetch("samples", "addOne", {
    sample,
  });

  return sample;
}
